import { render, staticRenderFns } from "./MarketingIndex.vue?vue&type=template&id=a976af58&scoped=true"
import script from "./MarketingIndex.vue?vue&type=script&lang=js"
export * from "./MarketingIndex.vue?vue&type=script&lang=js"
import style0 from "./MarketingIndex.vue?vue&type=style&index=0&id=a976af58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a976af58",
  null
  
)

export default component.exports